import type { NavTourTrack } from './resolveNavTourSteps';

export const NAV_TOUR_STORAGE_PREFIX = 'communio:nav-tour';

const LOOPBACK_HOSTS = new Set(['', 'localhost', '127.0.0.1', '[::1]', '::1']);

export function normalizeNavTourSlug(slug: string): string {
  return slug.trim().toLowerCase() || 'default';
}

export function navTourStorageKey(track: NavTourTrack, slug: string): string {
  return `${NAV_TOUR_STORAGE_PREFIX}:${track}:done:${normalizeNavTourSlug(slug)}`;
}

export function readNavTourDone(track: NavTourTrack, slug: string): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(navTourStorageKey(track, slug)) === '1';
  } catch {
    return true;
  }
}

export function writeNavTourDone(track: NavTourTrack, slug: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(navTourStorageKey(track, slug), '1');
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearNavTourDone(track: NavTourTrack, slug: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(navTourStorageKey(track, slug));
  } catch {
    /* ignore */
  }
}

/** Slug from tenant hostname when not passed explicitly. */
export function slugFromHostname(hostname: string): string {
  const h = hostname.trim().toLowerCase().replace(/\.$/, '');
  if (LOOPBACK_HOSTS.has(h) || h.endsWith('.localhost')) {
    return 'local';
  }
  const parts = h.split('.');
  if (parts.length >= 3 && parts.slice(-2).join('.') === 'communiosocial.com') {
    return parts[0] ?? 'local';
  }
  return h;
}
